import { useEffect } from "react"

import WaitingForActionModalBody from "#/shared/components/modals/WaitingForActionModalBody"
import { ComponentStepProps } from "#/ui/Modal"

export default function WaitingForTransaction({
  onClickContinue,
}: ComponentStepProps) {
  useEffect(() => {
    // TODO: Temporary solution. Use the `useWriteContract` hook from `wagmi`
    // and trigger function from the smart contract that adds liquidity to the
    // pool.
    const timeout = setTimeout(() => {
      onClickContinue()
    }, 3_000)

    return () => {
      clearTimeout(timeout)
    }
  }, [onClickContinue])

  return <WaitingForActionModalBody title="Waiting for transaction..." />
}
